/* POUR HAPPINESS – Rezeptwelt: Filter, Suche, "Mehr laden" und abhakbare Zutaten. Ohne Abhängigkeiten. */
(function () {
  'use strict';

  function initList(root) {
    var grid = root.querySelector('[data-ph-grid]');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-ph-item]'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ph-filter]'));
    var search = root.querySelector('[data-ph-search]');
    var more = root.querySelector('[data-ph-more]');
    var empty = root.querySelector('[data-ph-empty]');
    var status = root.querySelector('[data-ph-status]');
    var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 9;
    var visibleLimit = pageSize;
    var activeCat = 'all';

    // Redaktionelle Sortierung: sort_order aufsteigend, danach neueste zuerst.
    items.sort(function (a, b) {
      var sa = parseInt(a.getAttribute('data-sort'), 10), sb = parseInt(b.getAttribute('data-sort'), 10);
      if (isNaN(sa)) sa = 99999; if (isNaN(sb)) sb = 99999;
      if (sa !== sb) return sa - sb;
      return (b.getAttribute('data-date') || '').localeCompare(a.getAttribute('data-date') || '');
    });
    items.forEach(function (el) { grid.appendChild(el); });

    function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }

    function apply() {
      var q = search ? norm(search.value.trim()) : '';
      var matches = items.filter(function (el) {
        var okCat = activeCat === 'all' || el.getAttribute('data-category') === activeCat;
        var okQ = !q || norm(el.getAttribute('data-search')).indexOf(q) !== -1;
        return okCat && okQ;
      });
      items.forEach(function (el) { el.hidden = true; });
      matches.forEach(function (el, i) { el.hidden = i >= visibleLimit; });
      if (empty) empty.hidden = matches.length !== 0;
      if (more) more.hidden = matches.length <= visibleLimit;
      if (status) status.textContent = matches.length + (matches.length === 1 ? ' Rezept' : ' Rezepte');
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeCat = btn.getAttribute('data-ph-filter');
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        visibleLimit = pageSize;
        apply();
        try {
          var url = new URL(window.location.href);
          if (activeCat === 'all') url.searchParams.delete('kategorie'); else url.searchParams.set('kategorie', activeCat);
          window.history.replaceState({}, '', url);
        } catch (e) {}
      });
    });
    if (search) search.addEventListener('input', function () { visibleLimit = pageSize; apply(); });
    if (more) more.addEventListener('click', function () {
      var firstNew = visibleLimit;
      visibleLimit += pageSize;
      apply();
      var shown = items.filter(function (el) { return !el.hidden; });
      var target = shown[firstNew] && shown[firstNew].querySelector('a');
      if (target) target.focus();
    });

    // Kategorie aus der URL übernehmen (?kategorie=Tapas), z. B. aus der Breadcrumb der Detailseite.
    try {
      var pre = new URL(window.location.href).searchParams.get('kategorie');
      if (pre) {
        var match = buttons.filter(function (b) { return b.getAttribute('data-ph-filter') === pre; })[0];
        if (match) { activeCat = pre; buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === match ? 'true' : 'false'); }); }
      }
    } catch (e) {}
    apply();
  }

  function initIngredients(root) {
    var key = 'ph-recipe-ing:' + (root.getAttribute('data-recipe') || '');
    var boxes = Array.prototype.slice.call(root.querySelectorAll('input[type="checkbox"]'));
    var saved = [];
    try { saved = JSON.parse(window.sessionStorage.getItem(key) || '[]'); } catch (e) {}
    boxes.forEach(function (box, i) {
      if (saved.indexOf(i) !== -1) box.checked = true;
      box.addEventListener('change', function () {
        var on = boxes.map(function (b, j) { return b.checked ? j : -1; }).filter(function (j) { return j >= 0; });
        try { window.sessionStorage.setItem(key, JSON.stringify(on)); } catch (e) {}
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ph-recipe-list]'), initList);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ph-ingredients]'), initIngredients);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
